import mixpanel from "mixpanel-browser";
import { mixpanelConfig } from "./mixpanel.config";

const isProduction = process.env.REACT_APP_ANALYTICS_ENV === "production";

if (isProduction) {
  mixpanel.init(mixpanelConfig.apiKey, {
    ip: false,
  });
}

const templates = {
  insert: (macro) => `${macro} inserted`,
  edit: (macro) => `${macro} edited`,
  load: (macro) => `${macro} loaded`,
  default: (macro) => `${macro}`,
};

export const analytics = {
  logEvent: ({ name, template = "default", params = {} }) => {
    if (!isProduction) return;
    const host = window.AP._hostOrigin;

    if (!name?.length) {
      throw new Error("Can not log analytics data without name.");
    }

    try {
      mixpanel.track(templates[template](name), { ...params, host });
    } catch (error) {
      console.log("Failed to log event.");
    }
  },
};
